import React, { useState } from "react";
import { PopoverMenu } from "@deliverr/ui/lib-esm/PopoverMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { ManifestCarrier } from "sortation/utils/ManifestCarrier";

interface CarrierSelectProps {
  carrier: string;
  setCarrier: (carrier: string) => void;
}

const CarrierSelect: React.FC<CarrierSelectProps> = ({ carrier, setCarrier }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block", width: "100%", maxWidth: "200px" }}>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          cursor: "pointer",
          padding: "10px 14px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          backgroundColor: "#f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          transition: "background-color 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#e0e0e0";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f0f0f0";
        }}
      >
        <span>{carrier}</span>
        <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
      </div>
      {isExpanded && (
        <PopoverMenu.Container
          expanded={isExpanded}
          align="left"
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "6px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            marginTop: "4px",
            width: "100%",
          }}
        >
          <PopoverMenu.Item
            label="DHL"
            onClick={() => {
              setCarrier(ManifestCarrier.DHL);
              setIsExpanded(false);
            }}
          />
          <PopoverMenu.Item
            label="RRDonnelley"
            onClick={() => {
              setCarrier(ManifestCarrier.RRDONNELLEY);
              setIsExpanded(false);
            }}
          />
        </PopoverMenu.Container>
      )}
    </div>
  );
};

export default CarrierSelect;
